import React from 'react';
import { formatDecimal, formatPercent } from './format';

export const StatRow = ({
  label,
  homeValue,
  awayValue,
  format = 'number',
  higherIsBetter = true
}: {
  label: string;
  homeValue: number | string | undefined;
  awayValue: number | string | undefined;
  format?: 'number' | 'percent' | 'decimal' | 'string';
  higherIsBetter?: boolean;
}) => {
  const homeNum = typeof homeValue === 'number' ? homeValue : parseFloat(String(homeValue) || '0');
  const awayNum = typeof awayValue === 'number' ? awayValue : parseFloat(String(awayValue) || '0');

  const homeHigher = homeNum > awayNum;
  const awayHigher = awayNum > homeNum;
  const homeBetter = higherIsBetter ? homeHigher : awayHigher;
  const awayBetter = higherIsBetter ? awayHigher : homeHigher;

  let formattedHome = String(homeValue ?? '-');
  let formattedAway = String(awayValue ?? '-');

  if (format === 'decimal' && typeof homeValue === 'number') {
    formattedHome = formatDecimal(homeValue);
  }
  if (format === 'decimal' && typeof awayValue === 'number') {
    formattedAway = formatDecimal(awayValue);
  }
  if (format === 'percent' && typeof homeValue === 'number') {
    formattedHome = formatPercent(homeValue);
  }
  if (format === 'percent' && typeof awayValue === 'number') {
    formattedAway = formatPercent(awayValue);
  }

  return (
    <div className="grid grid-cols-3 gap-2 py-1 border-b border-gray-100 dark:border-gray-800 last:border-0">
      <div className={`text-right font-medium ${homeBetter && homeNum !== awayNum ? 'text-green-600 dark:text-green-400' : 'text-gray-800 dark:text-gray-200'}`}>
        {formattedHome}
      </div>
      <div className="text-center text-gray-500 dark:text-gray-400 text-sm">{label}</div>
      <div className={`text-left font-medium ${awayBetter && homeNum !== awayNum ? 'text-green-600 dark:text-green-400' : 'text-gray-800 dark:text-gray-200'}`}>
        {formattedAway}
      </div>
    </div>
  );
};
